module.exports = __webpack_public_path__ + "img/cloud-meatball.39a85599.svg";